import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'components/ui';
import {useMobile} from 'utils/hooks';
import styles from './PracticeTestFinishModal.module.scss';

export interface PracticeTestFinishModalProps {
  onClick(): void;
  onClose(): void;
}

function PracticeTestFinishModal({
  onClick,
  onClose,
}: PracticeTestFinishModalProps): JSX.Element {
  const {isMobile} = useMobile();

  return (
    <Modal
      isOpen
      onClose={onClose}
      vw={!isMobile ? 70 : 100}
      maxWidth={384}
      maxHeight={400}
      clickOutsideToClose={false}
    >
      <div className={styles.PracticeTestFinishModal}>
        <div className={styles.Icon}>
          <FontAwesomeIcon icon={['fad', 'hourglass-start']} size="2x" />
        </div>
        <>
          <h3>Tempo Esgotado</h3>
          <p>Siga para a próxima etapa para verificar seu resultado.</p>
          <Button text="Continuar" onClick={onClick} variant="tertiary" />
        </>
      </div>
    </Modal>
  );
}

export default PracticeTestFinishModal;
